// extracted by mini-css-extract-plugin
module.exports = {"root":"style-module__root___9917V","progress":"style-module__progress___zSJOV","text":"style-module__text___Y01Ng"};